export default __webpack_public_path__ + "static/media/link_blue.dbbabdbf.svg";